<template lang="pug">
	div
		.breadcrumbs
			//-.breadcrumb-back
				back-button
			.breadcrumb-link
				router-link.chapter(to="/") Home
			.breadcrumb-link(v-if="page !== 'About Theha'")
				router-link.chapter(to="/about-theha") About Theha
			.breadcrumb-link
				| {{ page }}
		vue-page-transition(name="fade")
			router-view
</template>

<script>
import BackButton from '@/components/BackButton'

export default {
	name      : 'AboutTheWorldWrapper',
	components: {
		BackButton
	},
	data () {
		return {
			page: this.$route.name
		}
	},
	watch: {
		'$route' (val) {
			this.$nextTick(() => {
				this.page = this.$route.name

				if (document.activeElement) document.activeElement.blur()
			})
		}
	}
}
</script>
